import { createDataState } from "@/utils";
import { TARGET_DATA, welcomeDataFields } from "@/config";

// Default state
const defaultState = () => {
  return {
    [TARGET_DATA.welcome]: createDataState(welcomeDataFields, {
      choose_problem: "",
      name_input: "",
      age_select: "",
      choose_gender: "",
      choose_treatments: [],
      choose_phobias: [],
      choose_path: "myself",
    }),
  };
};

// State object
const state = defaultState();

// Getter functions
const getters = {
  getOnboardingData(state) {
    return state[TARGET_DATA.welcome];
  },
};

// Actions
const actions = {
  setData({ commit }, data) {
    commit("SET_FORM_DATA", data);
  },
  resetState({ commit }) {
    commit("RESET_STATE");
  },
};

// Mutations
const mutations = {
  SET_FORM_DATA(state, { fieldName, data }) {
    state[TARGET_DATA.welcome][fieldName] = data;
  },
  RESET_STATE(state) {
    Object.assign(state, defaultState());
  },
};

export default {
  name: "WelcomeModule",
  dynamic: true,
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
